// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.0043 1.59007L3.00017 1.58594L1.58594 3.00013L6.51395 7.92826L10 12.8174V21H14V15.4145L20.9997 22.4144L22.4097 21.0045L3 1.59437L3.0043 1.59007Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.27 11.0362L21 3H7.23399L15.27 11.0362Z"}}]};

const FilterOffFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'filter-off-filled',
    ref,
    icon: element,
  },
));

FilterOffFilledIcon.displayName = 'FilterOffFilledIcon';

export default FilterOffFilledIcon;
